import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

const myContext = createContext();

export const MyContextWrapper = ({ children }) => {
  const [account, setAccount] = useState("");
  const [isAccountInfoUpdated, setIsAccountInfoUpdated] = useState(0);
  const [isProfileInfoLoading, setIsProfileInfoLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [allUseEffectRunCode, setAllUseEffectRunCode] = useState();
  const [cartItems, setCartItem] = useState([]);
  const [token, setToken] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [run, setRun] = useState(false);
  const [isLoginPasswordVisible, setIsLoginPasswordVisible] = useState(false);
  const [isRegisterPasswordVisible, setIsRegisterPasswordVisible] =
    useState(false);
  const [isRegisterPasswordVisibleTwo, setIsRegisterPasswordVisibleTwo] =
    useState(false);
  const [isAdminSidebarOpen, setIsAdminSidebarOpen] = useState(false);
  const [path, setPath] = useState();
  const [runPath, setRunPath] = useState(0);
  const [isProductAddPopUpOpen, setIsProductAddPopUpOpen] = useState(false);
  const [singleProductPathId, setSingleProductPathId] = useState(null);
  const [adminValidationRun, setAdminValidationRun] = useState(0);
  const [adminValidation, setAdminValidation] = useState(null);

  const toastStyle = { position: "top-center", autoClose: 2000 };

  const toggleRunPath = () => {
    setRunPath(runPath + 1);
  };

  // storing cart data to localStorage and others cart related functionality
  const localStorageData = JSON.parse(localStorage.getItem("cartItem")) || [];
  useEffect(() => {
    setCartItem(localStorageData);
  }, [run]);

  const toggleRun = () => {
    setRun((prev) => !prev);
  };
  // console.log(cartItems);
  const handleAddProduct = (product) => {
    const isProductExist = localStorageData?.find((singleItem) => {
      return singleItem._id === product._id;
    });
    if (isProductExist) {
      const data = localStorageData?.map((item) => {
        return item._id === product._id
          ? { ...isProductExist, quantity: isProductExist.quantity + 1 }
          : item;
      });
      localStorage.setItem("cartItem", JSON.stringify(data));
    } else {
      localStorage.setItem(
        "cartItem",
        JSON.stringify([...cartItems, { ...product, quantity: 1 }])
      );
      toast.success("Product added to Cart!", toastStyle);
    }
    toggleRun();
  };
  //   Handle remove product
  const handleRemoveProduct = (product) => {
    const isProductExist = localStorageData?.find((singleItem) => {
      return singleItem._id === product._id;
    });
    if (isProductExist.quantity === 1) {
      const fildat = localStorageData.filter((item) => {
        return item._id !== product._id;
      });
      localStorage.setItem("cartItem", JSON.stringify(fildat));
      toast.success("Product removed from cart!", toastStyle);
    } else {
      const dt = localStorageData.map((item) => {
        return item._id === product._id
          ? { ...isProductExist, quantity: isProductExist.quantity - 1 }
          : item;
      });
      localStorage.setItem("cartItem", JSON.stringify(dt));
    }
    toggleRun();
  };
  //   const handle single product delete
  const deleteSingleItem = (product) => {
    const bal = localStorageData.filter((item) => {
      return item._id !== product._id;
    });
    localStorage.setItem("cartItem", JSON.stringify(bal));
    toast.success("Product removed from cart!", toastStyle);
    toggleRun();
  };

  //   clear the cart
  const clearCart = () => {
    localStorage.removeItem("cartItem");
    toggleRun();
    toast.success("Cart is empty!", toastStyle);
  };
  const totalPrice = cartItems?.reduce(
    (price, item) => price + item.quantity * item.price?.cost,
    0
  );

  // calculate total cart item
  const totalItem = cartItems?.reduce(
    (quantity, item) => quantity + item.quantity,
    0
  );
  // console.log(totalItem, totalPrice);
  //   end of cart functionality

  // getting token data from localStorage and setting it to 'token' useState.(In login page I saved token data in localStorage)
  let localStorageTokenData = JSON.parse(localStorage.getItem("tokens")) || [];

  const localStorageIsAdminData = JSON.parse(localStorage.getItem("isAdmin"));

  useEffect(() => {
    setToken(localStorageTokenData);
    setIsAdmin(localStorageIsAdminData);
  }, [allUseEffectRunCode]);
  // console.log(localStorageTokenData);

  // const getting current user data
  // https://stechnology.up.railway.app/getuserdetails
  const UserData = async () => {
    setIsProfileInfoLoading(true);
    try {
      const res = await axios.get(
        "https://stechbackend-9r4c.onrender.com/getuserdetails",
        {
          headers: { Authorization: token },
          withCredentials: true,
        }
      );
      if (res.status === 201) {
        setAccount(res.data);
        setIsProfileInfoLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    UserData();
  }, [token, isAccountInfoUpdated]);

  // this function for if user update account info then again run the above useEffect
  const toggleUpdatedAccountInfo = () => {
    setIsAccountInfoUpdated(isAccountInfoUpdated + 1);
  }

  // logout user
  const logoutUser = async (navigate) => {
    // https://stechbackend-9r4c.onrender.com
    try {
      const res = await axios.get(
        "https://stechbackend-9r4c.onrender.com/logout",
        {
          headers: { Authorization: token },
          withCredentials: true,
        }
      );
      if (res.status === 201) {
        localStorage.removeItem("tokens");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("isValidateAdmin");
        setAdminValidationRun(2);
        setAllUseEffectRunCode(2);
        setAccount("");
        navigate("/");
        toast.success("successfully logout!");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // my password visible funtionality
  const toggleLoginPassword = () => {
    setIsLoginPasswordVisible(!isLoginPasswordVisible);
  };
  const toggleRegisterPassword = () => {
    setIsRegisterPasswordVisible(!isRegisterPasswordVisible);
  };
  const toggleRegisterPasswordTwo = () => {
    setIsRegisterPasswordVisibleTwo(!isRegisterPasswordVisibleTwo);
  };

  // admin validation data getting from localStorage setting to state
  const localStorageAdminValidation =
    localStorage.getItem("isValidateAdmin") || null;

  useEffect(() => {
    setAdminValidation(localStorageAdminValidation);
  }, [adminValidationRun]);
  // // admin panel sidebar open and close functionality
  // const OpenSideBar = () => {
  //   setIsAdminSidebarOpen(true);
  // }
  // const CloseSideBar = () => {
  //   setIsAdminSidebarOpen(false);
  // }

  // getting all products
  const GetAllProducts = async () => {
    await axios
      .get("https://stechbackend-9r4c.onrender.com/getproducts")
      .then((res) => {
        if (res.status === 201) {
          setAllProducts(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    GetAllProducts();
  }, []);

  return (
    <myContext.Provider
      value={{
        account,
        toggleUpdatedAccountInfo,
        isProfileInfoLoading,
        setAccount,
        allProducts,
        cartItems,
        handleAddProduct,
        handleRemoveProduct,
        deleteSingleItem,
        clearCart,
        totalPrice,
        totalItem,
        toggleRun,
        setAllUseEffectRunCode,
        token,
        isAdmin,
        logoutUser,
        localStorageTokenData,
        toggleLoginPassword,
        isLoginPasswordVisible,
        toggleRegisterPassword,
        isRegisterPasswordVisible,
        toggleRegisterPasswordTwo,
        isRegisterPasswordVisibleTwo,
        isAdminSidebarOpen,
        setIsAdminSidebarOpen,
        path,
        setPath,
        toggleRunPath,
        runPath,
        isProductAddPopUpOpen,
        setIsProductAddPopUpOpen,
        singleProductPathId,
        setSingleProductPathId,
        adminValidation,
        setAdminValidation,
        adminValidationRun,
        setAdminValidationRun,
      }}
    >
      {children}
    </myContext.Provider>
  );
};

export const MyContextSupply = () => {
  return useContext(myContext);
};
